import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

export enum SurveyStatus {
  NotStarted = 'Not started',
  InProgress = 'In progress',
  SignedOff = 'Signed off',
}
// Needs to be before namespace is defined
const SURVEY_STATUSES: ReadonlySet<SurveyStatus> = new Set(
  Object.values(SurveyStatus) as SurveyStatus[],
)
export namespace SurveyStatus {
  export const ALL: readonly SurveyStatus[] = Array.from(SURVEY_STATUSES)
  export const isSurveyStatus = TypeChecker.Factory.oneOf(SURVEY_STATUSES)
  export const assertIsSurveyStatus: TypeAsserter<SurveyStatus> =
    TypeAsserter.Factory.from(isSurveyStatus)
}
